import { get } from 'lodash-es'

export const getStatus = response => {
  return {
    code: get(response, ['error', 'status']) || get(response, ['data', 'code']),
    message: get(response, ['error', 'message']) || get(response, ['data', 'message']),
  }
}
